import { useCallback } from 'react';
import { useWtrStore } from 'redux/hooks';
import { getScrollState } from 'redux/modules/scroll-session-storage/selectors';
import { setScrollStateInSessionStorage } from 'utils/scroll-session-storage';

export const useSetScrollState = (lineNumber: string) => {
  const store = useWtrStore();

  const setScrollState = useCallback(() => {
    const scrollState = getScrollState(store.getState());

    setScrollStateInSessionStorage(scrollState, lineNumber);
  }, [lineNumber, store]);

  return { setScrollState };
};
